import { Badge, Text } from '@mantine/core';
import { IconAlertSquareRounded } from '@tabler/icons-react';
import type { AiChange } from '~/types';

export type ErrorInfo = {
  stepId: string;
  stepIndex: number;
  stepDescription: string;
  operationId?: string;
  operationDescription?: string;
  error: string;
};

/**
 * Inline error details display component.
 * Used in the Stably trace view to show error information directly under the action.
 * For hover card behavior with step info, use ErrorHoverCard instead.
 */
export default function ErrorDetails({ error, isAutoHealed = false }: { error: ErrorInfo; isAutoHealed: boolean }) {
  return (
    <div className="ml-4 mt-2 flex-1">
      <div className="mb-1 flex items-center justify-between">
        <div className="flex items-center gap-2">
          <IconAlertSquareRounded
            size={16}
            className="text-red-600 dark:text-red-400"
          />
          <Text
            size="sm"
            fw={500}
            c="red"
          >
            Error details:
          </Text>
        </div>
        {isAutoHealed ?
          <Badge
            size="xs"
            color="violet"
            variant="light"
          >
            Fixed: Successfully auto-healed
          </Badge>
        : null}
      </div>

      <Text
        size="sm"
        className="whitespace-pre-wrap rounded bg-neutral-100 p-3 font-mono text-red-700 dark:bg-neutral-900 dark:text-red-300"
      >
        {error.error}
      </Text>
    </div>
  );
}

export const checkIsErrorAutoHealed = ({ error, aiChanges }: { error: ErrorInfo; aiChanges: AiChange[] }) => {
  return aiChanges.some(
    (aiChange) => aiChange.stepId === error.stepId && aiChange.stepIndex === error.stepIndex && aiChange.isSuccess,
  );
};
